// extracted by mini-css-extract-plugin
module.exports = {"TermsLayout":"Terms-module--TermsLayout--3fOWW","TermsHeader":"Terms-module--TermsHeader--3_ev0"};